import { createAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosRequestConfig, ResponseType } from "axios";
import { AnyActionOrThunk } from "../../reducers";

export const apiCallBegan = createAction<
  {
    onStart?: AnyActionOrThunk;
    onSuccess?: AnyActionOrThunk | ((response: AxiosResponse | any) => void);
    onFailure?: AnyActionOrThunk | ((error: AxiosError) => void);
    onSuccessMessage?: string;
    onFailureMessage?: string;
    responseType?: ResponseType;
  } & AxiosRequestConfig,
  "API_CALL_BEGAN"
>("API_CALL_BEGAN");
export const apiCallSuccess = createAction("API_CALL_SUCCESS");
export const apiCallFailed = createAction<unknown, "API_CALL_FAILED">("API_CALL_FAILED");
